import React from "react";
import { motion } from "framer-motion";
import { Sparkle } from "@phosphor-icons/react";

const PILLS = ["Fresh Ideas", "New Trends", "Passion", "Profit"];

export const IntroStatement = () => (
  <section data-testid="intro-statement" className="py-20 md:py-28 bg-[#0A1521] border-b border-[#F6F4F0]/10">
    <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold mb-8">
          <Sparkle size={14} weight="fill" /> High School Entrepreneurs
        </div>
        <p className="font-heading font-light text-2xl sm:text-3xl lg:text-4xl text-[#F6F4F0] leading-snug">
          Two young founders. <span className="text-gold italic">Three years</span> deep in social media marketing —
          catching trends before they peak and building brands with real{" "}
          <span className="text-gold italic ml-1 sm:ml-2">passion.</span>
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-10">
          {PILLS.map((p) => (
            <span key={p} className="text-xs uppercase tracking-[0.2em] border border-[#C8A96A]/40 text-gold px-5 py-2">
              {p}
            </span>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
